import { render, staticRenderFns } from "./ModalGradeContentSetting.vue?vue&type=template&id=1c86057b&scoped=true"
import script from "./ModalGradeContentSetting.vue?vue&type=script&lang=js"
export * from "./ModalGradeContentSetting.vue?vue&type=script&lang=js"
import style0 from "./ModalGradeContentSetting.vue?vue&type=style&index=0&id=1c86057b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c86057b",
  null
  
)

export default component.exports